import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import * as Sentry from '@sentry/react'
import App from './App.tsx'
import './index.css'
import { isProduction } from './lib/siteConfig'

// Initialize Sentry only if DSN is configured
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryDsn && sentryDsn !== 'YOUR_SENTRY_DSN_HERE') {
  Sentry.init({
    dsn: sentryDsn,
    sendDefaultPii: true,
    environment: isProduction() ? 'production' : 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: isProduction() ? 0.1 : 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Ignore non-critical errors in development
    beforeSend(event, hint) {
      if (import.meta.env.DEV) {
        // Only send critical errors in development
        if (event.level !== 'error' && event.level !== 'fatal') {
          return null;
        }
      }
      return event;
    },
  });
}

// Setup user identification function for Sentry
window.identifyUser = (user: any, profile: any) => {
  if (user && profile) {
    const userName = profile.first_name && profile.last_name
      ? `${profile.first_name} ${profile.last_name}`
      : profile.email;

    // Identify in Sentry (for error tracking)
    Sentry.setUser({
      id: user.id,
      email: profile.email,
      username: userName,
    });
  }
};

// Hide loading skeleton when React is ready
const loadingSkeleton = document.getElementById('loading-skeleton');
if (loadingSkeleton) {
  loadingSkeleton.style.display = 'none';
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
